import { FormModel } from 'main/common/form-state-manager/FormModel'
import { BankAccountTypeEnum } from 'main/modules/financial/enums/BankAccountTypeEnum'
import React from 'react'
import { AutocompletePickerCP } from 'main/common/components/form-fields/autocomplete-picker/AutocompletePickerCP'
import { INameAndCodeResponseDTO } from 'main/common/dtos/responses/INameAndCodeResponseDTO'
import { IAutocompleteCommonProps } from 'main/common/components/form-fields/autocomplete-picker/inner/IAutocompleteCommonProps'
import { BankAccountRequests } from 'main/modules/financial/services/bank-account/BankAccountRequests'

interface IAutocompleteBankAccountCPProps<FModelTP extends FormModel = any> extends IAutocompleteCommonProps<INameAndCodeResponseDTO, FModelTP> {
    label: string
    type?: BankAccountTypeEnum
}

/**
 * COMPONENTE
 * Seletor de bancos - Lists todos bancos cadastrados na franquia
 */
export function AutocompleteBankAccountCP<FModelTP extends FormModel = any>(props: IAutocompleteBankAccountCPProps<FModelTP>): JSX.Element {

    return (
        <AutocompletePickerCP<INameAndCodeResponseDTO, FModelTP>
            requestConfigGetter={BankAccountRequests.searchConfig}
            customFilters={{ type: props.type }}
            showOptionsOnLoad={true}
            // NOTE: Usando operador 'spread' excepcionalmente para garantir compatibilidade com props extendidas de outro componente
            {...props/* eslint-disable-line react/jsx-props-no-spreading */}
        />
    )
}